import { camelToKebab } from '../utils/utils'

import AppSidebar from './layout/AppSidebar.vue'
import AppHeader from './layout/AppHeader.vue'
import AppAnonymousHeader from './layout/AppAnonymousHeader.vue'
import AppFooter from './layout/AppFooter.vue'
import AppOnboarding from './layout/AppOnboarding.vue'

import Spinner from './Spinner.vue'
import Dropdown from './Dropdown.vue'
import SwoopLogo from './SwoopLogo.vue'
import InputCheckbox from './forms/Checkbox.vue'
import InputRadio from './forms/Radio.vue'
import DateDropdown from './forms/DateDropdown.vue'
import SlideToggle from './animations/SlideToggle.vue'

// Re-export layout components to have access from one place
export { AppSidebar, AppHeader, AppAnonymousHeader, AppFooter, AppOnboarding }

// Components to automatically registered
const componentsToRegister = { Spinner, Dropdown, SwoopLogo, InputCheckbox, InputRadio, SlideToggle, DateDropdown }

export default function registerComponents(Vue) {
  Object.keys(componentsToRegister).forEach((componentKey, index) => {
    // transform name to kebab case ( IconFrame -> icon-frame )
    const name = camelToKebab(componentKey)
    Vue.component(name, componentsToRegister[componentKey])
  })
}
